(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-sidebar-menu"] && !Shopify.designMode) return;
  try {
    
(()=>{const rail=document.querySelector('[data-hnb-rail]');if(!rail||rail.dataset.ready)return;document.addEventListener('DOMContentLoaded',()=>{if(!window.matchMedia('(min-width: 750px)').matches)return;const mark=rail.querySelector('.hnb-rail__brand-mark');const logo=document.querySelector('.header-section .menu-logo-image img, .header-section .header-logo__image');if(mark&&logo){const clone=logo.cloneNode(true);clone.alt='';mark.replaceChildren(clone)}});rail.dataset.ready='1';const qs=s=>document.querySelector(s),open=(s)=>qs(s).showModal();rail.querySelector('[data-hnb-skin-open]').onclick=()=>open('[data-hnb-skin-modal]');rail.querySelector('[data-hnb-founder-open]').onclick=()=>{const d=qs('[data-hnb-founder-modal]');d.querySelector('iframe').src=rail.dataset.founderVideo;d.showModal()};rail.querySelector('[data-hnb-ingredients-open]').onclick=()=>open('[data-hnb-ingredients-modal]');rail.querySelector('[data-hnb-reviews-open]').onclick=()=>open('[data-hnb-reviews-modal]');document.querySelectorAll('[data-hnb-close]').forEach(b=>b.onclick=()=>b.closest('dialog').close());qs('[data-hnb-founder-modal]').addEventListener('close',e=>e.currentTarget.querySelector('iframe').src='');document.querySelectorAll('[data-hnb-lang]').forEach(b=>b.onclick=()=>{document.querySelectorAll('[data-hnb-lang]').forEach(x=>x.classList.toggle('is-active',x===b));document.querySelectorAll('[data-hnb-copy]').forEach(x=>x.hidden=x.dataset.hnbCopy!==b.dataset.hnbLang)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
